import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from '@mui/material';

const SessionExpiryDialog = ({ open, secondsRemaining = 60, onExtend, onEnd }) => {
  return (
    <Dialog open={open} onClose={onEnd} maxWidth="xs" fullWidth>
      <DialogTitle>Session is expiring</DialogTitle>
      <DialogContent>
        <Stack alignItems="center" spacing={1.5} sx={{ py: 1 }}>
          <Typography variant="body1" align="center">
            No activity detected. Your session will end soon.
          </Typography>
          <Typography variant="h6" align="center">
            {secondsRemaining}s remaining
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Stack direction="row" spacing={2} justifyContent="center" sx={{ width: '100%' }}>
          <Button variant="outlined" color="inherit" onClick={onEnd} size="large">
            End Session
          </Button>
          <Button variant="contained" color="primary" onClick={onExtend} size="large" autoFocus>
            Extend
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiryDialog;
